<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div class="card">
	<div class="card-header bg-theme mb-0">
		<h5 class="card-title text-light mb-0">
			{{pagetitle}}
			@if (navbar.hasRosterAccess()) {
			<button class="btn btn-xs btn-light float-end" (click)="createEdit(null)">
				<fa-icon [icon]="['fas', 'plus']"></fa-icon>
				Create Roster
			</button>
			}
		</h5>
	</div>
	<div class="card-body py-0 px-1">
		@if(navbar.hasRosterAccess()){
		<div class="table-responsive">
			<table *ngIf="dtOptions.pagingType" datatable [dtOptions]="dtOptions"
				class="table table-bordered table-hover">
				<thead>
					<tr class="table_head">
						<th style="width: 25% !important;">Employee</th>
						<th style="width: 10% !important;">From</th>
						<th style="width: 10% !important;">To</th>
						<th style="width: 10% !important;">Action</th>
					</tr>
				</thead>
				<tbody *ngIf="dataList?.length !== 0">
					<tr *ngFor="let v of dataList;let i = index;">
						<td>
							{{ v.emp_code?.first_name }} {{ v.emp_code?.last_name }}
						</td>
						<td>{{ v.from_date }}</td>
						<td>{{ v.to_date }}</td>
						<td>
							@if (navbar.hasRosterAccess()) {
							<button class="btn btn-xs btn-primary ms-1" matTooltip="Edit" (click)="createEdit(v)">
								<fa-icon [icon]="['fas', 'edit']"></fa-icon>
							</button>
							<button class="btn btn-xs btn-danger ms-1" matTooltip="Delete"
								(click)="deleteConfirm(v.id)">
								<fa-icon *ngIf="showDeleteLoader !== v.id" [icon]="['fas', 'times']"></fa-icon>
								<fa-icon *ngIf="showDeleteLoader === v.id" [icon]="['fas', 'spinner']"
									animation="spin"></fa-icon>
							</button>
							}
						</td>
					</tr>
				</tbody>
				<tbody *ngIf="dataList?.length === 0">
					<tr>
						<td colspan="7" class="text-center">No data found!</td>
					</tr>
				</tbody>
			</table>
		</div>
		}@else {
		<h3 class="text-center">You don't have access to this section.</h3>
		}
	</div>
</div>
<app-roster-form [userList]="userList" (created)="refreshTable()">
</app-roster-form>